export default __webpack_public_path__ + "static/media/ISKO_CLASS-4_SYLLABUS.32b1fe2d.pdf";